class ArViewerButton extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('click', (ev) => {
      if (this.dataset.modelSrc) {
        ev.preventDefault();
        window.dispatchEvent(new CustomEvent('arviewer:showmodel', { detail: this.dataset.modelSrc }));
      }
    });
    this.addEventListener('ar-viewer-button:set-inactive', (ev) => {
      this.removeAttribute('data-model-src');
      this.classList.add('hidden');
      this.closest('.ar-wrapper')?.removeAttribute('open');
    });
    this.addEventListener('ar-viewer-button:set-active', (ev) => {
      this.setAttribute('data-model-src', ev.detail);
      this.classList.remove('hidden');
      this.closest('.ar-wrapper')?.setAttribute('open', 'open');
    });
  }
}

window.customElements.define('ar-viewer-button', ArViewerButton);
